/**
 * Mixin hiển thị cảnh báo không có quyền thực hiện chức năng.
 * Dùng msgBoxV2 chuẩn toàn repo (RoleList.vue:142), không dùng popup custom.
 * Gọi:
 * - showNoPermissionWarning() → message mặc định "Vui lòng liên hệ quản trị"
 * - showNoPermissionWarning(me.$t('i18nCommon.NoPermissionSyncInput')) → message riêng (1 phần quyền)
 * - showNoPermissionWarning(msg, me.$t('i18nCommon.NoPermissionPartTitle')) → message + title riêng (1 phần quyền)
 * - Trả về Promise từ msgBoxV2.show → caller có thể await chờ user đóng popup
 */
export const noPermissionWarningMixin = {
	methods: {
		/**
		 * Kiểm tra NSD có quyền làm việc theo enum quyền hay không
		 * @param {Number} permissionEnum - enum trong WorkPermissionEnum
		 * @returns {Boolean} true = có quyền
		 */
		checkPermission(permissionEnum) {
			const me = this;
			if (me.User && me.User.Role === me.$ms.enum.Role.Admin) {
				return true;
			}
			return me.$ms.commonFunc.isShowPermissionWork(
				permissionEnum,
				me.WorkPermission
			);
		},

		/**
		 * Hiển thị cảnh báo không có quyền thực hiện chức năng
		 * @param {String} message - nội dung cảnh báo (mặc định liên hệ quản trị)
		 */
		async showNoPermissionWarning(message) {
			const me = this;
			return me.$ms.msgBoxV2.show({
				message: message || me.$t('i18nCommon.NoPermissionContactAdmin'),
				title: me.$t('i18nCommon.NoPermissionFunctionTitle'),
				isIconClose: true,
				btnConfig: [
					{
						key: 'Close',
						target: 'Right',
						text: me.$t('i18nCommon.Close'),
						focus: true,
					},
				],
			});
		},
	},
};
